import React from "react";
import { Div } from "../../atoms/Div";
import { Button } from "../../atoms/Button";
import { Lin } from "../../atoms/Lin"
import Collapse from '@material-ui/core/Collapse';


const SuccessModal = ({ success, closeModals }) => {
    return (
        <Collapse in={success.collapse}>
            <Div className="success-modal">
                <Div className="success-modal__left-side">
                    <Div className="success-modal__icon-check">
                    </Div>
                    <Div className="success-modal__main-text">
                        {success.text}
                    </Div>
                    {success.withlink ?
                        <Div>
                            {success.linktype === "n" ?
                                <Lin path={success.linkto} className="success-modal__normal-link">
                                    {success.linktext}
                                </Lin> :
                                <Lin path={success.linkto} className="success-modal__special-link">
                                    {success.linktext}
                                </Lin>
                            }
                        </Div>
                        : null}
                </Div>
                <Div className="success-modal__right-side">
                    <Button className="success-modal__close-button" onClick={closeModals} />
                </Div>
            </Div>
        </Collapse>
    );
};
export default SuccessModal;
